"use client"
import { PlanATimelineDiagramResponsive } from './PlanATimelineDiagramResponsive'
import { useStandaloneDiagramProps } from './useStandaloneDiagramProps'

// Renders the Plan A timeline diagram outside the playbook tree, driving
// navigation through the URL hash (see useStandaloneDiagramProps for how
// the playbook callbacks are reconstructed).
export const PlanATimelineDiagramStandalone = ({
  // See useStandaloneDiagramProps: pins currentPlan='A' when this diagram
  // caps the inline Plan A continuation shown after finishing another plan.
  inlinePlanAContinuation = false,
}: { inlinePlanAContinuation?: boolean } = {}) => {
  const diagramProps = useStandaloneDiagramProps(inlinePlanAContinuation)
  return <PlanATimelineDiagramResponsive {...diagramProps} />
}
